const initialState = {
  billingCycles: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_BILLING_CYCLES': {
      return {
        ...state,
        billingCycles: action.payload,
      };
    }
    default:
      return state;
  }
};
